/**
 * AdminSession（React に依存しない状態機械）を React へ繋ぐだけの層。
 * 判断は session.ts 側にあり、ここには置かない。
 */

import {
  createContext,
  useContext,
  useEffect,
  useSyncExternalStore,
  type ReactNode,
} from "react";

import type { AdminSession, AuthState } from "./session";

const SessionContext = createContext<AdminSession | null>(null);

export function AuthProvider({
  session,
  children,
}: {
  session: AdminSession;
  children: ReactNode;
}) {
  useEffect(() => {
    void session.initialize();
  }, [session]);

  return (
    <SessionContext.Provider value={session}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession(): AdminSession {
  const session = useContext(SessionContext);
  if (session === null) {
    throw new Error("AuthProvider の外で useSession を呼んでいます");
  }
  return session;
}

export function useAuthState(): AuthState {
  const session = useSession();
  return useSyncExternalStore(session.subscribe, () => session.snapshot());
}
